module.exports = __webpack_public_path__ + "img/flecha.a7c00ab2.svg";